export class LimitedTime {
    startDayTime: number;
    endDayTime: number;
    weekDays: string[];
    startTimestamp: number;
    endTimestamp: number;
}